import Api from '@/services/Api'

// Korisnici jedne firme. Admin firme smije aktivirati/deaktivirati korisnika
// svoje firme i postaviti mu novu lozinku.
//
// Prava provjerava posluzitelj, iz tokena - ne iz onoga sto ekran posalje.
export default {
  // {CompanyId}
  popis (query) {
    return Api().get('firma/korisnici', {params: query})
  },
  // {CompanyId, Activ}
  aktivan (userId, podaci) {
    return Api().put(`firma/korisnici/${userId}/aktivan`, podaci)
  },
  // {CompanyId, password}
  lozinka (userId, podaci) {
    return Api().put(`firma/korisnici/${userId}/lozinka`, podaci)
  }
}
